import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import { memberApi } from '../../config/axios-config';
import { analyticsTrackClickEvent } from '../../utils/analytics/analytics-utils';


const useStyles = makeStyles(() => ({
  greyContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderRadius:'4px',
    width: '802px',
    height: ' 674px',
    padding: '60px 88px 85px 88px',
    display: 'flex',
    alignItems:'center',
    flexDirection:'column'
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    margin: '40px'
  },
  heading:{
    fontFamily: 'HCo Whitney SSm, Ideal Sans, system-ui, sans-serif',
    fontWeight: '700',
    fontSize:'22px'
  }
  ,
  contentBox:{
      display:'flex',
      alignItems:'center',
      flexDirection:'column'
  },
  label:{
    fontFamily: 'HCo Whitney SSm, Ideal Sans, system-ui, sans-serif',
    fontWeight: '500',
    fontSize:'16px',
    color: 'rgba(0, 0, 0, 0.54)',
    marginTop:'40px'
  },
  labelBold:{
    fontFamily: 'HCo Whitney SSm, Ideal Sans, system-ui, sans-serif',
    fontWeight: '700',
    fontSize:'16px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  buttonStyle: {
    width: 305,
    height: 48,
    marginTop:'20px'
  }
}));
const AutopayConfirmation = () => {
  const classes = useStyles();
  const history = useHistory();
  const [emailOptLanguage, setEmailOptLanguage] = React.useState('');

  const paymentAmount = history.location.state.paymentAmount;
  const emailOpt = history.location.state.emailOpt;
  const last4 = history.location.state.last4;
  
  React.useEffect(() => {
    analyticsTrackClickEvent('payments_autopay_confirmation_viewed', {eventCategory: 'Home Page Pathing'});
    memberApi
            .get('/v3/my/billing/auto-payment')
            .then(res => {
                console.log(res.data);
            })
            .catch(err => console.log(err));
  }, []);
  
  React.useEffect(() => {
    if (emailOpt == 'yes') {
        setEmailOptLanguage('Yes, send email communications');
    } else if (emailOpt == 'no') {
      setEmailOptLanguage('No, do not send email communications');
    }
}, []);

  console.log(history, 'test');
  console.log(paymentAmount, 'payment');
  console.log(emailOpt, 'email');

  const handleClick = () => {
    history.push('/payment');
  };


  return (
    <Box className={classes.container}>
      <Box className={classes.greyContainer}>
        <div className={classes.icon}>
          <svg
            width="108"
            height="108"
            viewBox="0 0 108 108"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="54" cy="54" r="54" fill="#D9D9D9" />
            <path
              d="M27.8243 77.4054C26.7221 77.4054 25.7577 76.9921 24.9311 76.1655C24.1045 75.3388 23.6912 74.3744 23.6912 73.2723V30.5632C23.6912 29.461 24.1045 28.4966 24.9311 27.67C25.7577 26.8433 26.7221 26.43 27.8243 26.43H32.3019V22.2969H36.7794V26.43H60.2006V22.2969H64.6781V26.43H69.1557C70.2579 26.43 71.2223 26.8433 72.0489 27.67C72.8755 28.4966 73.2888 29.461 73.2888 30.5632V73.2723C73.2888 74.3744 72.8755 75.3388 72.0489 76.1655C71.2223 76.9921 70.2579 77.4054 69.1557 77.4054H27.8243ZM27.8243 73.2723H69.1557V43.6514H27.8243V73.2723ZM27.8243 39.5183H69.1557V30.5632H27.8243V39.5183ZM27.8243 39.5183V30.5632V39.5183ZM48.49 55.362C47.7093 55.362 47.0549 55.0979 46.5268 54.5698C45.9986 54.0417 45.7346 53.3873 45.7346 52.6066C45.7346 51.8259 45.9986 51.1714 46.5268 50.6433C47.0549 50.1152 47.7093 49.8511 48.49 49.8511C49.2707 49.8511 49.9251 50.1152 50.4532 50.6433C50.9814 51.1714 51.2454 51.8259 51.2454 52.6066C51.2454 53.3873 50.9814 54.0417 50.4532 54.5698C49.9251 55.0979 49.2707 55.362 48.49 55.362ZM37.4683 55.362C36.6876 55.362 36.0332 55.0979 35.5051 54.5698C34.9769 54.0417 34.7129 53.3873 34.7129 52.6066C34.7129 51.8259 34.9769 51.1714 35.5051 50.6433C36.0332 50.1152 36.6876 49.8511 37.4683 49.8511C38.249 49.8511 38.9034 50.1152 39.4315 50.6433C39.9597 51.1714 40.2237 51.8259 40.2237 52.6066C40.2237 53.3873 39.9597 54.0417 39.4315 54.5698C38.9034 55.0979 38.249 55.362 37.4683 55.362ZM59.5117 55.362C58.731 55.362 58.0766 55.0979 57.5485 54.5698C57.0203 54.0417 56.7563 53.3873 56.7563 52.6066C56.7563 51.8259 57.0203 51.1714 57.5485 50.6433C58.0766 50.1152 58.731 49.8511 59.5117 49.8511C60.2924 49.8511 60.9468 50.1152 61.4749 50.6433C62.0031 51.1714 62.2671 51.8259 62.2671 52.6066C62.2671 53.3873 62.0031 54.0417 61.4749 54.5698C60.9468 55.0979 60.2924 55.362 59.5117 55.362ZM48.49 66.3837C47.7093 66.3837 47.0549 66.1196 46.5268 65.5915C45.9986 65.0634 45.7346 64.409 45.7346 63.6283C45.7346 62.8476 45.9986 62.1931 46.5268 61.665C47.0549 61.1369 47.7093 60.8728 48.49 60.8728C49.2707 60.8728 49.9251 61.1369 50.4532 61.665C50.9814 62.1931 51.2454 62.8476 51.2454 63.6283C51.2454 64.409 50.9814 65.0634 50.4532 65.5915C49.9251 66.1196 49.2707 66.3837 48.49 66.3837ZM37.4683 66.3837C36.6876 66.3837 36.0332 66.1196 35.5051 65.5915C34.9769 65.0634 34.7129 64.409 34.7129 63.6283C34.7129 62.8476 34.9769 62.1931 35.5051 61.665C36.0332 61.1369 36.6876 60.8728 37.4683 60.8728C38.249 60.8728 38.9034 61.1369 39.4315 61.665C39.9597 62.1931 40.2237 62.8476 40.2237 63.6283C40.2237 64.409 39.9597 65.0634 39.4315 65.5915C38.9034 66.1196 38.249 66.3837 37.4683 66.3837ZM59.5117 66.3837C58.731 66.3837 58.0766 66.1196 57.5485 65.5915C57.0203 65.0634 56.7563 64.409 56.7563 63.6283C56.7563 62.8476 57.0203 62.1931 57.5485 61.665C58.0766 61.1369 58.731 60.8728 59.5117 60.8728C60.2924 60.8728 60.9468 61.1369 61.4749 61.665C62.0031 62.1931 62.2671 62.8476 62.2671 63.6283C62.2671 64.409 62.0031 65.0634 61.4749 65.5915C60.9468 66.1196 60.2924 66.3837 59.5117 66.3837Z"
              fill="black"
            />
            <path
              d="M67.779 52.6055C58.653 52.6055 51.2465 60.0121 51.2465 69.138C51.2465 78.264 58.653 85.6706 67.779 85.6706C76.905 85.6706 84.3116 78.264 84.3116 69.138C84.3116 60.0121 76.905 52.6055 67.779 52.6055Z"
              fill="#D9D9D9"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M54.0009 69.1404C54.0009 61.5354 60.173 55.3633 67.778 55.3633C75.383 55.3633 81.5551 61.5354 81.5551 69.1404C81.5551 76.7454 75.383 82.9175 67.778 82.9175C60.173 82.9175 54.0009 76.7454 54.0009 69.1404ZM69.7209 78.3301V77.531C72.1181 77.0764 74.0056 75.6986 74.0332 73.1774C74.0332 69.7056 71.0573 68.507 68.2743 67.7906C65.4913 67.0742 64.5958 66.3164 64.5958 65.1591C64.5958 63.8365 65.8358 62.8997 67.9023 62.8997C69.6383 62.8997 70.5062 63.5748 70.8231 64.6218C70.9609 65.1178 71.3742 65.476 71.8839 65.476H72.2421C73.055 65.476 73.6336 64.6769 73.3581 63.9192C72.8346 62.4588 71.6359 61.274 69.7347 60.8056V59.9514C69.7347 58.9456 68.9081 58.119 67.9023 58.119H67.8886C66.8828 58.119 66.0562 58.9456 66.0562 59.9514V60.778C63.6865 61.2878 61.7715 62.8308 61.7715 65.2005C61.7715 68.0248 64.1136 69.43 67.5304 70.2567C70.6027 70.9869 71.2089 72.0615 71.2089 73.205C71.2089 74.0454 70.6027 75.3955 67.9023 75.3955C65.8909 75.3955 64.8438 74.6791 64.4443 73.6458C64.2514 73.1636 63.8381 72.8192 63.3283 72.8192H62.9977C62.1711 72.8192 61.5786 73.6596 61.8955 74.4174C62.5844 76.112 64.2101 77.1177 66.0424 77.5034V78.3301C66.0424 79.3358 66.8691 80.1624 67.8748 80.1624H67.8886C68.8943 80.1624 69.7209 79.3358 69.7209 78.3301Z"
              fill="black"
            />
          </svg>
        </div>
       <div className={classes.contentBox}>
       <Typography variant="h2" className={classes.heading}>All finished! You’ve successfully set up autopay.</Typography>
       <Typography variant="body1" className={classes.label}>Payment amount:</Typography>
       <Typography variant="body1" className={classes.labelBold}>Full monthly premium amount ${paymentAmount}</Typography>
       <Typography variant="body1" className={classes.label}>Payment source:</Typography>
       <Typography variant="body1" className={classes.labelBold}>{`Card ending in *****${last4}`}</Typography>
       <Typography variant="body1" className={classes.label}>Email communications:</Typography>
       <Typography variant="body1" className={classes.labelBold}>{emailOptLanguage}</Typography>
       <br/>
       {/* <Typography variant="body1" className={classes.label}>You first auto payment will take effect <b>08/01/2022</b></Typography> */}

       </div>
       <Button  variant="contained"
                color="primary" onClick={handleClick} className={classes.buttonStyle}>Back To Payments</Button>
      </Box>
    </Box>
  );
};

export default AutopayConfirmation;
